import axios from 'axios'
import baseService from './baseService'
import dealerTagData from './data/dealerTag'
import DealerTagNumber from '@/models/DealerTagNumber'

const appService = {
  findAllByDealerId (dealerId) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(dealerTagData.all)
      } else {
        axios
          .get('/dealertagnumber/findallbydealerid?dealerId=' + dealerId, baseService.defaultConfig)
          .then(response => {
            let apiResults = {...response.data}
            if (!apiResults.errors) {
              apiResults.results = DealerTagNumber.fromAPIList(response.data.results)
            }
            resolve(apiResults)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  all (searchCriteria) {
    return new Promise((resolve, reject) => {
      axios.cancel('dealer-tag-number-load-all')
      if (baseService.isTestMode) {
        resolve(dealerTagData)
      } else {
        axios
          .post('/dealertagnumber/list', searchCriteria, {...baseService.defaultConfig, requestId: 'dealer-tag-number-load-all'})
          .then(response => {
            let apiResults = {...response.data}
            apiResults.results = DealerTagNumber.fromAPIList(response.data.results)
            resolve(apiResults)
          })
          .catch(error => {
            if (axios.isCancel(error)) {
              console.log('dealer tag number all cancelled')
            } else {
              reject(error.response.data)
            }
          })
      }
    })
  }
}

export default appService
